var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timeline-entry-item',{staticClass:"note system-note being-posted fade-in-half"},[_c('div',{staticClass:"timeline-content"},[_c('em',[_vm._v(_vm._s(_vm.note.body))])])])}
var staticRenderFns = []

export { render, staticRenderFns }